import React, { useState } from 'react';
import { Link } from 'react-router-dom'
import 'css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';
import carewindow_blue from 'images/carewindow_blue.png'
import 'style.css';
import 'css/responsive.css';
import 'css/perfect-scrollbar.css';
import 'css/custom.css';
import 'css/color_2.css';
import 'css/bootstrap-select.css';
import { sendResetPasswordEmail } from 'js/Api/index'; 

function Send_Email() {
  const [email, setEmail] = useState('')
  const navigate = useNavigate()
  
  const handleSubmit = async (e) => {
    e.preventDefault() // Prevent default form submission

    if (!email) {
      alert("Please enter an email address.")
      return
    }

    const result = await sendResetPasswordEmail(email);
    
    if (result.success) {
      toast.success(result.message);
      setTimeout(() => navigate('/'), 2000);
    } else {
      toast.error(result.message);
    }
  }

  return (
    <div className="full_container">
      <Toaster />
      <div className="container">
        <div className="center verticle_center full_height">
          <div className="login_section">
            <div className="logo_login">
              <div className="center">
                <img className="login-carewindow" width="500" src={carewindow_blue} alt="CareWindow" />
              </div>
            </div>

            <div className="login_form">
              <text style={{color:'black'}}>Enter your email address below and we'll send you a link to reset your password.</text>
              <form id="email-form" onSubmit={handleSubmit}>
                <fieldset>
                  <div className="field">
                    <label className="label_field">Email Address</label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>

                  <div className="field margin_0">
                    <label className="label_field hidden">hidden label</label>

                    <button style={{width:'120px'}} className="btn cur-p btn-primary" type="submit" >
                      Send Email
                    </button>
                    <Link className="forgot" to="/">Return to Login Page</Link>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Send_Email